export enum IngredientsCategoryEnum {
    VEGETABLES_FRUITS = "Vegetables & Fruits",
    DAIRY_MEAT_PRODUCTS = "Dairy & Meat-Based Products",
    GRAINS_PULSES_FLOURS = "Grains, Pulses & Flours",
    SPICES_SEASONINGS = "Spices & Seasonings",
    OILS = "Oils",
    MISCELLANEOUS = "Miscellaneous",
  }